<template>
  <div class="introduction">
    <img :src="bannerImg" class="bannerImg">
    <div class="introduction_content">
      <div class="bread d-flex">
        <h3 class="flex-auto">
          <a class="text-blue">{{title}}</a>
        </h3>
        <div class="text-gray_dark d-flex">
          <span>
            <img src="@/assets/images/p.png" class="pic">
          </span>
          {{$store.state.langData.nowAddress}}：
          <router-link :to="'/about?type=1'">{{$store.state.langData.about}}</router-link>>
          <a>{{title}}</a>
        </div>
      </div>
      <h3 class="text-blue">招聘岗位信息</h3>
      <div class="table">
        <tbody>
          <tr>
            <td>招聘岗位：</td>
            <td>{{info.post}}</td>
          </tr>
          <tr>
            <td>招聘部门：</td>
            <td>{{info.department}}</td>
          </tr>
          <tr>
            <td>招聘人数：</td>
            <td>{{info.num}}</td>
          </tr>
          <tr>
            <td>发布日期：</td>
            <td>{{info.releaseTime}}</td>
          </tr>
          <tr>
            <td>结束日期：</td>
            <td>{{info.endTime}}</td>
          </tr>
          <tr>
            <td>工作地区：</td>
            <td>{{info.workArea}}</td>
          </tr>
          <tr>
            <td>岗位描述：</td>
            <td>{{info.describe}}</td>
          </tr>
          <tr>
            <td>岗位要求：</td>
            <td>{{info.requirement}}</td>
          </tr>
          <tr>
            <td>应聘邮箱：</td>
            <td>{{info.email}}</td>
          </tr>
          <tr>
            <td>联系电话：</td>
            <td>{{info.mobile}}</td>
          </tr>
          <tr>
            <td>联系人：</td>
            <td>{{info.contacts}}</td>
          </tr>
          <tr>
            <td>通讯地址：</td>
            <td>{{info.address}}</td>
          </tr>
        </tbody>
      </div>
      <h3 class="else_text" @click="isShowFunction()">我要应聘</h3>
      <div v-if="isShow">
      <h3 class="text-blue" style="text-align:center;">
        <span>如您想应聘此岗位，请如实填写，并提交给我们！</span>
      </h3>
        <div class="introduce">
          <label>姓名：</label>
          <input type="text" placeholder v-model="submitInfo.name">
        </div>
        <div class="introduce">
          <label>性别：</label>
          <select v-model="submitInfo.gender">
            <option value>请选择性别</option>
            <option value="男">男</option>
            <option value="女">女</option>
          </select>
        </div>
        <div class="introduce">
          <label>年龄：</label>
          <input
            type="text"
            placeholder
            v-model="submitInfo.age"
            onkeyup="value=value.replace(/^(0+)|[^\d]+/g,'')"
          >
        </div>
        <div class="introduce">
          <label>籍贯：</label>
          <input type="text" placeholder v-model="submitInfo.nativePlace">
        </div>
        <div class="introduce">
          <label>学历：</label>
          <input type="text" placeholder v-model="submitInfo.education">
        </div>
        <div class="introduce">
          <label>专业：</label>
          <input type="text" placeholder v-model="submitInfo.major">
        </div>
        <div class="introduce">
          <label>毕业院校：</label>
          <input type="text" placeholder v-model="submitInfo.graduationSchool">
        </div>
        <!-- <div class="introduce">
            <label>岗位要求：</label>
            <input type="text" placeholder="" />
        </div>-->
        <div class="introduce">
          <label>期望薪资/月：</label>
          <input type="text" placeholder v-model="submitInfo.expectSalary">
        </div>
        <div class="introduce">
          <label>e-mail：</label>
          <input type="text" placeholder v-model="submitInfo.email">
        </div>
        <div class="introduce">
          <label>联系电话：</label>
          <input type="text" placeholder v-model="submitInfo.mobile">
        </div>
        <div class="introduce">
          <label>工作经历：</label>
          <input type="text" placeholder v-model="submitInfo.wordExperience">
        </div>
        <div class="introduce">
          <span>自我介绍：</span>
          <input type="text" placeholder v-model="submitInfo.introduceSelf">
        </div>
        <div class="introduce">
          <span>备注补充：</span>
          <input type="text" placeholder v-model="submitInfo.remark">
        </div>
        <div class="submitSpan" style="position:relative;margin-left:130px;margin-top:20px;">
          <div class="upload">{{submitInfo.resumeUrl ? '已上传' : '上传附件简历'}}</div>
          <span>{{submitInfo.resumeUrl}}</span>
          <input v-if="!submitInfo.resumeUrl" type="file" id="file" @change="file()">
          <div id="progress" v-if="showProgress">
            <div class="progress-item"></div>
          </div>
          <div class="delete_file" v-if="showProgress" @click="clear()">删除附件</div>
        </div>
      <div class="submit" @click="submit()">保存并提交</div>
      </div>
    </div>
  </div>
</template>

<script>
import { getBanner, uploader } from "@/api";
import { getRecruiDetail, submitRecrui } from "@/api/hjy";

export default {
  name: "introduction",
  data() {
    return {
      id: "",
      bannerImg: "", //banner
      info: {},
      submitInfo: {
        postId: "", //id
        name: "",
        age: "",
        education: "",
        email: "",
        expectSalary: "",
        gender: "",
        graduationSchool: "",
        introduceSelf: "",
        major: "",
        mobile: "",
        nativePlace: "",
        remark: "",
        resumeUrl: "",
        wordExperience: "",
      },
      showProgress: false,
        isShow:false,
    };
  },

  //请求方法
  methods: {
    isShowFunction(){
      this.isShow = true;
    },
    // 获取banner
    getBannerImg() {
      getBanner({ params: "2", ad_type: "10" }).then(res => {
        this.bannerImg = res.list[0].imageUrl;
      });
      this.bannerShow = true;
    },
    getDetail() {
      console.log(this.id);
      getRecruiDetail({ id: this.id }).then(res => {
        this.info = res.data;
        this.submitInfo.postId = this.id;
      });
    },
    file() {
      this.showProgress = true;
      let v = this;
      var file = document.querySelector("#file").files[0];
      //创建formdata对象
      var formdata = new FormData();
      formdata.append("file", file);
      //创建xhr，使用ajax进行文件上传
      var xhr = new XMLHttpRequest();
      xhr.open("post", "http://116.62.56.81:8080/abgw/api/upload/upload");
      //回调
      xhr.onreadystatechange = function() {
        if (xhr.readyState == 4 && xhr.status == 200) {
          v.submitInfo.resumeUrl = JSON.parse(xhr.responseText).data;
        }
      };
      //获取上传的进度
      xhr.upload.onprogress = function(event) {
        if (event.lengthComputable) {
          var percent = (event.loaded / event.total) * 100;
          document.querySelector("#progress .progress-item").style.width =
            percent + "%";
        }
      };
      //将formdata上传
      xhr.send(formdata);
    },
    clear() {
      let v = this;
      v.showProgress = false;
      v.submitInfo.resumeUrl = "";
      document.querySelector("#progress .progress-item").style.width = "0";
    },
    submit() {
      if (!this.submitInfo.name) {
        alert("请填写姓名");
      } else if (!this.submitInfo.gender) {
        alert("请选择性别");
      } else if (!this.submitInfo.age) {
        alert("请填写年龄");
      } else if (!this.submitInfo.nativePlace) {
        alert("请填写籍贯");
      } else if (!this.submitInfo.education) {
        alert("请填写学历");
      } else if (!this.submitInfo.major) {
        alert("请填写专业");
      } else if (!this.submitInfo.graduationSchool) {
        alert("请填写毕业院校");
      } else if (!this.submitInfo.expectSalary) {
        alert("请填写期望薪资/月 ");
      } else if (!this.submitInfo.email) {
        alert("请填写e-mail");
      } else if (!this.submitInfo.mobile) {
        alert("请填写联系方式");
      } else if (!this.submitInfo.wordExperience) {
        alert("请填写工作经历");
      } else {
        let submitInfo = this.submitInfo;
        // axios.post('recrui/application/submit',{
        //   postId: this.submitInfo.postId, //id
        //     name: this.submitInfo.name,
        //     age: this.submitInfo.age,
        //     education: this.submitInfo.education,
        //     email: this.submitInfo.email,
        //     expectSalary: this.submitInfo.expectSalary,
        //     gender: this.submitInfo.gender,
        //     graduationSchool: this.submitInfo.graduationSchool,
        //     introduceSelf: this.submitInfo.introduceSelf,
        //     major: this.submitInfo.major,
        //     mobile: this.submitInfo.mobile,
        //     nativePlace: this.submitInfo.nativePlace,
        //     remark: this.submitInfo.remark,
        //     resumeUrl: this.submitInfo.resumeUrl,
        //     wordExperience: this.submitInfo.wordExperience
        // }).then(res => {

        // });
        submitRecrui({
          postId: this.submitInfo.postId, //id
          name: this.submitInfo.name,
          age: this.submitInfo.age,
          education: this.submitInfo.education,
          email: this.submitInfo.email,
          expectSalary: this.submitInfo.expectSalary,
          gender: this.submitInfo.gender,
          graduationSchool: this.submitInfo.graduationSchool,
          introduceSelf: this.submitInfo.introduceSelf,
          major: this.submitInfo.major,
          mobile: this.submitInfo.mobile,
          nativePlace: this.submitInfo.nativePlace,
          remark: this.submitInfo.remark,
          resumeUrl: this.submitInfo.resumeUrl,
          wordExperience: this.submitInfo.wordExperience
        }).then(res => {
          if (res.data) {
            alert("提交成功！");
            location.reload();
          }
        });
      }
    }
  },
  computed: {
    title() {
      let title = this.$route.query.title;
      this.id = this.$route.query.id;
      let t = title;
      return t;
    },
    type() {
      return this.cleft.length > 0 ? this.cleft[0].type : "";
    }
  },
  mounted() {
    this.getBannerImg();
    this.getDetail();
  }
};
</script>

<style lang="stylus">
.introduction {
  .bannerImg {
    width: 1200px;
    height: auto;
    margin: 15px auto;
    display: block;
  }

  h2 {
    font-weight: normal;
    margin-bottom: 12px;
    color: #ED822A;
    font-size: 36px;

    span {
      color: #1278C6;
    }
  }

  .in_right {
    padding-left: 20px;
    margin-bottom: 49px;
  }

  p {
    line-height: 30px;
  }

  .introduction_content {
    border: 1px solid #d5d5d5;
    padding: 10px 200px;
    width: 1200px;
    margin: 20px auto;
  }

  .table {
    width: 100%;
    border-collapse: collapse;
    border-spacing: 0;
    margin-top: 20px;
    font-size: 14px;
    margin-bottom: 20px;

    tbody {
      width: 100%;
      display: block;
    }

    tr {
      line-height: 30px;
      width: 100%;
      display: block;

      td {
        background-clip: padding-box;
      }

      td:nth-child(1) {
        width: 102px;
        text-align: right;
        vertical-align:top;
      }

      td:nth-child(2) {
        width: 620px;
        padding-right: 28px;
        color: #666;
        text-align: left;
      }
    }
  }

  .text-blue {
    margin-bottom: 30px;

    span {
      font-size: 14px;
      font-weight: normal;
      margin-left: 5px;
    }
  }

  .else_text {
    text-align: center;
    width: 220px;
    height: 60px;
    background: #1278C6;
    border-radius: 10px;
    line-height: 60px;
    color: #fff;
    margin: 0 auto 20px;
  }

  .introduce {
    width: 780px;
    margin: 18px auto 0;
    overflow: hidden;

    label, span {
      font-size: 16px;
      color: #333;
      position: relative;
      text-align: right;
      width: 121px;
      display: inline-block;
    }

    label:before {
      content: '*';
      display: inline-block;
      margin-right: 4px;
      line-height: 1;
      font-family: SimSun;
      font-size: 12px;
      color: #ed4014;
    }

    input, select {
      border: 1px solid #E4EAEC;
      width: 650px;
      height: 46px;
      font-size: 16px;
      padding-left: 31px;
    }
  }

  .submit {
    width: 320px;
    height: 60px;
    background: #1278C6;
    border-radius: 4px;
    line-height: 60px;
    font-size: 18px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #FFFFFF;
    text-align: center;
    margin:30px auto 50px;
  }

  #progress {
    height: 10px;
    width: 300px;
    border: 1px solid #1278c6;
    position: absolute;
    border-radius: 5px;
    display: inline-block;
    top: 30px;
    left: 180px;
  }

  #progress .progress-item {
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    background: #819eb5;
    border-radius: 5px;
    transition: width 0.3s linear;
  }

  .upload {
    width: 160px;
    height: 42px;
    background: #E36C09;
    border-radius: 4px;
    text-align: center;
    line-height: 42px;
    color: #fff;
    font-size: 14px;
    font-weight: bold;
    display: inline-block;
    cursor: pointer;
  }

  .submitSpan span {
    font-size: 10px;
    vertical-align: top;
    margin-left: 20px;
  }

  #file {
    position: absolute;
    width: 160px;
    height: 42px;
    opacity: 0;
    top: 0;
    cursor: pointer;
    left: 0;
  }

  .delete_file {
    width: 110px;
    height: 42px;
    border: 1px solid #1278C6;
    border-radius: 4px;
    line-height: 42px;
    color: #1278C6;
    font-size: 14px;
    text-align: center;
    top: 22px;
    right: 0;
    position: absolute;
    cursor: pointer;
  }
}
</style>